import BoxListButton from "@components/BoxListButton";
import { AWARD_DETAIL, AWARD_MODIFY } from "@constants/routes";
import { awardCategoryMap } from "@helpers/award.helper";
import { timestampToString } from "@helpers/dates.format";
import { IAwardDB } from "@interfaces/award";

const listAwardMapper = (items: IAwardDB[], handleDelete: Function) =>
  items.map(({ uuid, year, category, artist, createdAt }) => ({
    uuid,
    year,
    artist,
    category: awardCategoryMap[category],
    createDate: timestampToString(createdAt),
    _createDateTs: createdAt ?? 0,
    actions: (
      <BoxListButton
        uuid={uuid}
        description={artist.artistName}
        detailRoute={AWARD_DETAIL}
        modifyRoute={AWARD_MODIFY}
        handleDelete={handleDelete}
      />
    ),
  }));

export default listAwardMapper;
